

import * as messages from '@radnuc/messages';
import * as thrift from 'thrift';

export function uuidToString(id?: messages.Core.UUID | null) {
    if (id === null || id === undefined)
        return 'INVALID';
    let data = (id.leastSignificantBits as unknown as thrift.Int64).toOctetString() +
        (id.mostSignificantBits as unknown as thrift.Int64).toOctetString();
    return data.slice(0, 8) + '-' + data.slice(8, 12) + '-' + data.slice(12, 16) +
        '-' + data.slice(16, 20) + '-' + data.slice(20);
}

export function generateRandomUuid() {
    return new messages.Core.UUID({
        leastSignificantBits: new thrift.Int64(window.crypto.getRandomValues(new Buffer(8))) as unknown as number,
        mostSignificantBits: new thrift.Int64(window.crypto.getRandomValues(new Buffer(8))) as unknown as number
    });
}
